import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Client } from '@modules/clients/models/client.model';

@Component({
    selector: 'app-avatar-cell',
    templateUrl: './avatar-cell.component.html',
    styleUrls: ['./avatar-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarCellComponent {
  readonly row = input.required<Client>();
}
